import { AMERICAN_EXPRESS_CARDS } from "@card-data/cards/amex/amex";
import { BANK_OF_AMERICA_CARDS } from "@card-data/cards/bankofamerica";
import { BARCLAYS_CARDS } from "@card-data/cards/barclays";
import { BREX_CARDS } from "@card-data/cards/brex";
import { CAPITAL_ONE_CARDS } from "@card-data/cards/capitalone";
import { CHASE_CARDS } from "@card-data/cards/chase/chase";
import { CITI_CARDS } from "@card-data/cards/citi";
import { COMENITY_CARDS } from "@card-data/cards/comenity";
import { FIRST_CARDS } from "@card-data/cards/first";
import { FNBO_CARDS } from "@card-data/cards/fnbo";
import { PENFED_CARDS } from "@card-data/cards/penfed";
import { PNC_CARDS } from "@card-data/cards/pnc";
import { SYNCHRONY_CARDS } from "@card-data/cards/synchrony";
import { TD_CARDS } from "@card-data/cards/td";
import { US_BANK_CARDS } from "@card-data/cards/usbank";
import { WELLS_FARGO_CARDS } from "@card-data/cards/wellsfargo";
import { z } from "zod";

import { DISCOVER_CARDS } from "./cards/discover";
import { WEB_BANK_CARDS } from "./cards/web-bank";
import { schemas } from "./generated/api.client";
import { CreditCard } from "./types";

export const CREDIT_CARDS: Array<CreditCard> = z
  .array(schemas.CreditCard)
  .parse([
    ...AMERICAN_EXPRESS_CARDS,
    ...BANK_OF_AMERICA_CARDS,
    ...BARCLAYS_CARDS,
    ...BREX_CARDS,
    ...CHASE_CARDS,
    ...CAPITAL_ONE_CARDS,
    ...CITI_CARDS,
    ...COMENITY_CARDS,
    ...DISCOVER_CARDS,
    ...FIRST_CARDS,
    ...FNBO_CARDS,
    ...PENFED_CARDS,
    ...PNC_CARDS,
    ...SYNCHRONY_CARDS,
    ...TD_CARDS,
    ...US_BANK_CARDS,
    ...WELLS_FARGO_CARDS,
    ...WEB_BANK_CARDS,
  ]);
